import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './modules/auth/services/auth.guard';
import { PartnerSignupService } from './services/partner-signup.service';
import { DEMO_ESCAPE_ROUTE } from './pages/demo/demo-mode.service';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  // Sin enlace de partner en el alta (R5, #20261023-090006): las URLs que ya se
  // repartieron llevan a la entrada y al login normales.
  { path: 'partner/:slug', redirectTo: '/auth/welcome', pathMatch: 'full' },
  { path: 'partner/:slug/login', redirectTo: '/auth/login', pathMatch: 'full' },
  // Enlace del correo de invitación al equipo de un partner (WS-2259):
  // pública, porque se llega sin sesión o sin cuenta.
  {
    path: 'accept-invitation',
    loadComponent: () =>
      import('./modules/auth/components/accept-invitation/accept-invitation.component').then(
        (m) => m.AcceptInvitationComponent,
      ),
  },
  // Dashboard de ejemplo sin registro («Explorar el dashboard» de la entrada,
  // #20261023-090014): pública, con «WAIIS S.L.» y sin peticiones al back.
  {
    path: 'demo',
    loadChildren: () => import('./pages/demo/demo.module').then((m) => m.DemoModule),
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: 'encuesta-movilidad',
    loadChildren: () =>
      import('./pages/visit-survey/visit-survey.module').then((m) => m.VisitSurveyModule),
  },
  // Con el ejemplo abierto, las rutas absolutas de «WAIIS S.L.» no salen de /demo.
  DEMO_ESCAPE_ROUTE,
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./_metronic/layout/layout.module').then((m) => m.LayoutModule),
  },
  { path: '**', redirectTo: 'error/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {
  // Se crea al arrancar la app: así `PartnerSignupService` borra al cargar el
  // partner que guardaban versiones anteriores (CR2, #20261023-090006).
  constructor(_partnerSignup: PartnerSignupService) {}
}
